import { render, staticRenderFns } from "./VendorListSideMenu.vue?vue&type=template&id=0ad9bd99"
import script from "./VendorListSideMenu.vue?vue&type=script&lang=js"
export * from "./VendorListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad9bd99')) {
      api.createRecord('0ad9bd99', component.options)
    } else {
      api.reload('0ad9bd99', component.options)
    }
    module.hot.accept("./VendorListSideMenu.vue?vue&type=template&id=0ad9bd99", function () {
      api.rerender('0ad9bd99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorListSideMenu.vue"
export default component.exports